import { FaChartBar, FaCheckCircle } from 'react-icons/fa';
export const KPI_CARDS = [
  { key: 'total', label: 'Certificados Emitidos', icon: FaChartBar, colorClass: 'bg-primary' },
  { key: 'validaciones', label: 'Vigentes', icon: FaCheckCircle, colorClass: 'bg-[#2E7D32]' },
];